export const REGISTRATION_PATH = '/hosts/register';

export const REGISTRATION_COMMANDS_DATA = 'REGISTRATION_COMMANDS_DATA';
export const REGISTRATION_COMMANDS_OS_TEMPLATE =
  'REGISTRATION_COMMANDS_OS_TEMPLATE';
export const REGISTRATION_COMMANDS = 'REGISTRATION_COMMANDS';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/RegistrationCommands/constants.js